export default "__VITE_ASSET__Bl5L7$_N__"